import React from "react";
import "./CorporateUpdate.css";
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import UpdateCorporateComponent from "./UpdateCorporate/component";
import UpdateAddDepartmentComponent from "./UpdateDepartment/component";
import UpdateUsageLimitComponent from "./UpdateCorporateUsageLimit/component";

const CorporateUpdateComponent = (props) => {
  const steps = [
    "Create Corporate",
    "Setup Department",
    "Usage Limit",
  ];

  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(-1);
  };

  return (
    <div className="corporate-create-layout">
      <Sidebar />

      <div className="corporate-create-content">
        <div className="corporate-create-header">
          <button onClick={handleClick} className="corporate-back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h2 className="corporate-create-title">
            {props.isUpdateMode ? "Update Corporate" : "Create a Corporate"}
          </h2>
        </div>

        <div className="corporate-stepper-wrapper">
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={props.activeStep}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
        
        <div className="corporate-form-wrapper">
          <div className="corporate-step-content">
            {props.activeStep === 0 && (
              <UpdateCorporateComponent
                createCorporateData={props.createCorporateData}
                handleChangeCorporate={props.handleChangeCorporate}
                setCreateCorporateData={props.setCreateCorporateData}
                handleRemoveDomain={props.handleRemoveDomain}
                loading={props.loading || props.fetchingCorporateDetails}
                isUpdateMode={props.isUpdateMode}
              />
            )}
            {props.activeStep === 1 && (
              <UpdateAddDepartmentComponent
                departments={props.departments}
                handleAddDepartment={props.handleAddDepartment}
                handleRemoveDepartment={props.handleRemoveDepartment}
                handleDepartmentChange={props.handleDepartmentChange}
                handleBalanceChange={props.handleBalanceChange}
                useDefaultDepartment={props.useDefaultDepartment}
                handleUseDefaultChange={props.handleUseDefaultChange}
                defaultBalance={props.defaultBalance}
                handleDefaultBalanceChange={props.handleDefaultBalanceChange}
                availableDepartments={props.availableDepartments}
                fetchingDepartments={props.fetchingDepartments}
                loading={props.loading || props.fetchingCorporateDetails}
              />
            )}
            {props.activeStep === 2 && (
              <UpdateUsageLimitComponent
                usageLimitRequired={props.usageLimitRequired}
                handleUsageLimitChange={props.handleUsageLimitChange}
                onLimitsChange={props.onLimitsChange}
                initialLimits={props.initialLimits}
                loading={props.loading || props.fetchingCorporateDetails}
              />
            )}
          </div>

          <div className="corporate-action-buttons">
            <Button
              className="corporate-action-cancel"
              onClick={props.handleClose}
              disabled={props.activeStep === 0 || props.loading || props.fetchingCorporateDetails}
            >
              Previous
            </Button>
            <Button
              className="corporate-action-save"
              variant="contained"
              onClick={props.handleNext}
              disabled={props.loading || props.fetchingCorporateDetails}
            >
              {props.loading || props.fetchingCorporateDetails ? "Processing..." : props.activeStep === steps.length - 1 ? "Save" : "Save and Continue"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateUpdateComponent;